import { ref } from 'vue';

export function useDragAndDrop() {
  // State
  const draggedItem = ref(null);
  const dragOverTarget = ref(null);

  // Methods
  const onDragStart = (event, item) => {
    draggedItem.value = item;
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/html', item.code || item.id);
  };

  const onDragEnd = () => {
    draggedItem.value = null;
    dragOverTarget.value = null;
  };

  const onDragOver = (event, target) => {
    event.preventDefault();
    dragOverTarget.value = target;
  };

  const onDragLeave = event => {
    // 컨테이너를 완전히 벗어났을 때만 dragOverTarget을 null로 설정
    if (!event.currentTarget.contains(event.relatedTarget)) {
      dragOverTarget.value = null;
    }
  };

  const onDrop = async (event, target, onDropCallback) => {
    event.preventDefault();
    dragOverTarget.value = null;

    if (!draggedItem.value || !onDropCallback) {
      draggedItem.value = null;
      return;
    }

    try {
      await onDropCallback(draggedItem.value, target);
    } catch (error) {
      console.error('드롭 처리 중 오류:', error);
    } finally {
      draggedItem.value = null;
    }
  };

  const isDraggedItem = item => {
    return draggedItem.value && draggedItem.value.code === item.code;
  };

  const isDragOverTarget = target => {
    return dragOverTarget.value === target;
  };

  return {
    // State
    draggedItem,
    dragOverTarget,

    // Methods
    onDragStart,
    onDragEnd,
    onDragOver,
    onDragLeave,
    onDrop,
    isDraggedItem,
    isDragOverTarget,
  };
}
